<template>
  <el-dialog :visible.sync="dialogVisible" width="65%" top="60px" :fullscreen="dialogFull"
             :close-on-click-modal="false" :destroy-on-close="true" append-to-body :modal-append-to-body="false"
             @close="handleClose">
    <template slot="title">
      <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        {{title}}
                                </span>
        <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"
           @click="dialogFull=!dialogFull"></i>

      </div>
    </template>
    <avue-form ref="formRef" @submit="submit" v-loading="loading" v-model="form" v-if="dialogVisible" :option="option">
    </avue-form>
    <template slot="footer">
      <el-button @click="formSubmit1" :disabled="disabled" size="small" type="primary"><span class="el-icon-check"></span>
        新 增</el-button>
      <el-button @click="handleClose" :disabled="disabled" size="small" style="margin-right:15px"><span
        class="el-icon-close"></span> 取消</el-button>
    </template>
  </el-dialog>
</template>
<script>
import option from "./addBlackWhiteCarPlus-form.js"
import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
import {
  addBatch,
} from '@/api/v4ward/park/blacklist/parkblacklist';
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      dialogFull: false,
      option: option,
      title: '批 量 新 增',
      form: {
        plateNumber: '',
        spaceIds: '',
        driverName: '',
        mobile: '',
        companyName: '',
        startDate: '',
        endDate: '',
        blackType: '',
        parkAreaRightType: '',
        remark: '',
      },
      blackOnloadType:'',
      spaceList: [],
      disabled:false,
    }
  },
  created() {
    this.initData();
  },
  watch:{
    'form.blackType'(val){
      let column = this.findObject(this.option.column,'parkAreaRightType');
      if(0 == val){
        column.display = true;
      }else {
        column.display = false;
      }
    },
  },
  methods: {
    formSubmit1() {
      this.disabled = true;
      this.$refs.formRef.submit();
      setTimeout(()=>{
        this.disabled = false;
      },5000)
    },
    submit(row,done) {
      addBatch(row).then(() => {
          this.$message.success('操作成功!');
          this.disabled = false;
          console.log("刷新页面重新查询");
          this.$emit('update', this.blackOnloadType);
          this.dialogVisible = false;
          done();
        },
        (error) => {
          this.disabled = false;
          window.console.log(error);
          done();
        });
    },
    openDialog(blackType) {
      this.disabled = false;
      this.loading = true;
      this.title = '批 量 新 增';
      this.initData(blackType);
      this.dialogVisible = true;
      this.loading = false;
    },
    handleClose() {
      this.$refs.formRef.resetForm();
      this.dialogVisible = false;
      this.loading = false;
    },
    //初始化数据
    initData(blackType) {
      this.blackOnloadType = blackType;
      //获取车场信息
      getSpaceTree(null, 2).then((data) => {
        this.spaceList = data.data;
        if (this.spaceList.length > 0) {
          let spaceIds = this.findObject(this.option.column, 'spaceIds');
          spaceIds.dicData = [{
            title: '全选',
            key: 0,
            children: this.spaceList
          }];
        }
      });
      //调整黑白名单下拉框数据
      if(0 == blackType){
        let blackTypeColumn = this.findObject(this.option.column, 'blackType');
        blackTypeColumn.dicData = [
          { label: '白名单', value: 0 }
        ];
      }else if(1 == blackType){
        let blackTypeColumn = this.findObject(this.option.column, 'blackType');
        blackTypeColumn.dicData = [
          { label: '黑名单', value: 1 }
        ];
      }
    },
    uploadBefore(file, done, loading) {
      let len = file.name.split('.').length;
      console.log(
        file.name.split('.')[len - 1] === 'png' || file.name.split('.')[len - 1] === 'jpeg'
      );
      console.log(file.type === 'image/jpeg' || file.type === 'image/png');
      console.log(file.type);
      const isImage =
        (file.name.split('.')[len - 1] === 'png' || file.name.split('.')[len - 1] === 'jpg') &&
        (file.type === 'image/jpeg' || file.type === 'image/png');
      console.log(isImage);
      const isLt500KB = file.size / 1024 < 500;
      if (!isImage) {
        this.$message.error('只能上传jpg/png格式的图片');
        loading();
        return;
      }
      if (!isLt500KB) {
        this.$message.error('上传图片大小不能超过500kb!');
        loading();
        return;
      }
      if (isImage && isLt500KB) {
        done();
      }
    },
  }
}
</script>
